export default function Terms() {
  return (
    <div className="container">
      <h1>Terms & Conditions</h1>

      <p>
        By accessing and using this website, you agree to comply with and be
        bound by the following terms and conditions. Please read them carefully.
      </p>

      <h3>Use of Website</h3>
      <p>
        This website is operated by Bloomora Naturals. The content provided is
        for general informational purposes only and may be updated without prior
        notice.
      </p>

      <h3>Products & Availability</h3>
      <p>
        Product availability, pricing, and descriptions are subject to change.
        Some products may be displayed as launching soon or out of stock.
      </p>

      <h3>Orders & Payments</h3>
      <p>
        We currently do not process online payments through this website. Orders
        may be enabled in the future as the business grows.
      </p>

      <h3>Intellectual Property</h3>
      <p>
        All content, logos, and materials on this website are the property of
        Bloomora Naturals and may not be used without permission.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        Bloomora Naturals shall not be liable for any direct or indirect damages
        arising from the use of this website.
      </p>

      <h3>Governing Law</h3>
      <p>
        These terms shall be governed by and construed in accordance with the
        laws of India.
      </p>
    </div>
  );
}
